<template>
  <div>
    <div class="header-sticky"><resend-bar /> <Header /></div>
    <div>
      <div class="header-banner">
        <div class="text-wrapper">
          <p class="m-0 mb-4 title">Crisis Help Info</p>
          <p class="title-text-element">
            It is not the intention of DoveMed to provide specific medical
            advice. DoveMed urges its users to consult a qualified healthcare
            professional for diagnosis and answers to their personal medical
            questions.
          </p>
        </div>
      </div>
      <div class="dovemed-wrapper my-5">
        <div class="info crisis">
          We realize health conditions can be very stressful and challenging to
          individuals and their loved ones. DoveMed recommends seeking help
          during difficult times from a network of your family members, friends,
          and healthcare professionals. Following are some resources that can
          help navigate a variety of challenging health situations:
        </div>
        <div class="text-main helpline">
          National Emergency Helpline: <span>911</span>
        </div>
        <div>
          <div class="text-main">Depression, Suicide, and Substance Abuse</div>
          <div>
            <div class="text-sub">National Suicide Prevention Lifeline:</div>
            <div class="info">
              <div>1-800-273-TALK (8255)</div>
              <div>Crisis Text Line : text HELLO to 741741</div>
            </div>
          </div>
          <div>
            <div class="text-sub">Samaritans:</div>
            <div class="info">
              <div>877-870-4673 (HOPE) (call/text)</div>
              <div>For immediate emotional support for those in distress</div>
            </div>
          </div>
        </div>
        <div>
          <div class="text-main">Sexual Abuse</div>
          <div>
            <div class="text-sub">National Sexual Assault Hotline:</div>
            <div class="info">
              <div>
                Website :
                <a target="_blank" href="https://rainn.org/"
                  >https://rainn.org/</a
                >
              </div>
              <div>Phone number : 1-800-656-4673</div>
            </div>
          </div>
        </div>
        <div>
          <div class="text-main">Elderly Adults and Veterans</div>
          <div>
            <div class="text-sub">Elder Abuse:</div>
            <div class="info">
              <div>Eldercare Locator : 800-677-1116 (toll-free)</div>
              <div>
                Website :
                <a
                  target="_blank"
                  href="https://www.nia.nih.gov/health/publication/elder-abuse"
                  >https://www.nia.nih.gov/health/publication/elder-abuse</a
                >
              </div>
            </div>
          </div>
          <div>
            <div class="text-sub">Veterans Crisis Line:</div>
            <div class="info">
              <div>800-273-8255 (press 1) or Text 838255</div>
            </div>
          </div>
        </div>
        <div>
          <div class="text-main">Child Welfare and Domestic Violence</div>
          <div>
            <div class="text-sub">Child Welfare Information:</div>
            <div class="info">
              <div>
                Website :<a
                  target="_blank"
                  href="https://www.childwelfare.gov/"
                >
                  https://www.childwelfare.gov/
                </a>
              </div>
              <div>Phone number : 1-800-4 A Child (1-800-422-4453)</div>
            </div>
          </div>
          <div>
            <div class="text-sub">National Domestic Violence Hotline:</div>
            <div class="info">
              <div>
                Website :
                <a target="_blank" href="http://www.thehotline.org/"
                  >http://www.thehotline.org/</a
                >
              </div>
              <div>Phone number : 1-800-799-7233</div>
            </div>
          </div>
        </div>
        <div>
          <div class="text-main">Poison Control</div>
          <div>
            <div class="text-sub">National Capital Poison Center (USA):</div>
            <div class="info">
              <div>3201 New Mexico Ave, Suite 310 Washington, DC 20016</div>
              <div>Administrative Line: (202) 362-3867</div>
              <div>Emergency Line: 1 (800) 222-1222</div>
              <div>Fax: (202) 362-8377</div>
              <div>Email: pc@poison.org</div>
              <div>
                Website: <a href="http://www.poison.org" target="_blank"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./HeaderGeneric";
import Footer from "./FooterGeneric";
import ResendBar from "./resendBar.vue";
import { required, email } from "vuelidate/lib/validators";
import { RepositoryFactory } from "../../repositories/RepositoryFactory";

const AppRepository = RepositoryFactory.get("app");

export default {
  name: "CrisisHelpline",
  components: {
    Header,
    Footer,
    ResendBar
  },

  data() {
    return {
      formData: {
        first_name: null,
        last_name: null,
        email: null,
        message: null
      },
      loading: false
    };
  },

  validations: {
    formData: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      email: {
        required,
        email
      },
      message: {
        required
      }
    }
  },

  methods: {
    send() {
      this.$v.formData.$touch();
      if (!this.$v.formData.$anyError) {
        this.loading = true;
        const payload = {
          first_name: this.formData.first_name,
          last_name: this.formData.last_name,
          email: this.formData.email,
          message: this.formData.message
        };
        AppRepository.contactForm(payload)
          .then(res => {
            this.$notification.success({
              message: "Success",
              description: "Sent successfully."
            });
            this.formData.first_name = null;
            this.formData.last_name = null;
            this.formData.email = null;
            this.formData.message = null;

            this.$v.$reset();
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
            this.$notification.success({
              message: "Error",
              description: `${err}`
            });
          });
      }
    }
  }
};
</script>

<style scoped>
.title-text-element {
  color: #ffffff !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;

  @media screen and (max-width: 580px) {
    font-size: 24px;
  }
}
.title-text-element:not(:last-child) {
  padding-top: 18px;
}

.input-label {
  font-weight: 700;
  color: #333333;
}
.header-banner {
  height: fit-content;
}
.text-main {
  font-size: 34px;
  line-height: 24px;
  color: #606f82;
  margin-bottom: 48px;
}
.text-sub {
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
  margin-bottom: 16px;
}
.info {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 48px;
}
.info a {
  color: #2a71d4 !important;
}
.crisis {
  margin-bottom: 48px;
}
.helpline {
  margin-bottom: 80px;
}
.helpline span {
  color: #2a71d4;
}
</style>



// WEBPACK FOOTER //
// src/components/App/CrisisHelpline.vue